import { formatEntityName, formatRoleName } from '../../../common';
import { createSchemaStatementHandler } from '../../createSchemaStatementHandler';
import { buildOperations, validateRole } from '../../utils';
export const aclDenyFieldsStmtInstruction = `
####  Denying access to fields in entities
- Syntax: \`deny <role1>[, <role2] to <accessTypes> entity <entityName> field <field1>[, <field2>];\`
- Example: \`deny editor to update entity Article field createdAt;\`
- Example: \`deny editor to read, create, update entity Article field title, content;\`
- Example: \`deny public, editor to create Article field title, content;\`
`;
export const stmtAclDenyFields = ({ roleNames, accessTypes, entityName, fieldNames }) => {
    return `deny ${roleNames.join(', ')} to ${accessTypes.join(', ')} entity ${entityName} fields ${fieldNames.join(', ')};`;
};
export const stmtForHumanAclDenyFields = ({ roleNames, accessTypes, entityName, fieldNames }) => {
    return `Deny the roles __${roleNames.join(', ')}__ to ${accessTypes.join(', ')} the fields __${fieldNames.join(', ')}__ of the entity __${entityName}__.`;
};
export const aclDenyFieldsHandler = createSchemaStatementHandler({
    type: 'deny field',
    parse: line => {
        const match = /^deny (?<roleNames>[\w, ]+) to (?<accessTypes>[\w, ]+) entity (?<entityName>\w+) fields? (?<fieldNames>[\w, ]+)/.exec(line);
        return match?.groups
            ? {
                type: 'deny field',
                roleNames: match.groups.roleNames.split(',').map(it => formatRoleName(it.trim())),
                accessTypes: match.groups.accessTypes
                    .split(',')
                    .map(item => item.trim())
                    .filter((it) => ['create', 'update', 'read'].includes(it)),
                entityName: formatEntityName(match.groups.entityName),
                fieldNames: match.groups.fieldNames?.split(',').map(item => item.trim()),
            }
            : null;
    },
    getHumanStmt: stmtForHumanAclDenyFields,
    apply: (stmt, builder) => {
        builder.updateSchema(it => {
            const entity = it.schema.model.entities[stmt.entityName];
            if (!entity) {
                throw new Error(`Entity ${stmt.entityName} does not exist`);
            }
            let updatedSchema = it;
            for (const role of stmt.roleNames) {
                validateRole(role);
                if (stmt.fieldNames.some(fieldName => !entity.fields[fieldName])) {
                    throw new Error(`Field ${stmt.fieldNames.find(fieldName => !entity.fields[fieldName])} does not exist in entity ${stmt.entityName}`);
                }
                const operations = buildOperations({ entity, fieldNames: stmt.fieldNames, accessTypes: stmt.accessTypes, predicate: false });
                updatedSchema = updatedSchema.createAclRole(role).updatePermissionsEntity(role, stmt.entityName, {
                    predicates: {},
                    operations,
                });
            }
            return updatedSchema;
        });
    },
});
//# sourceMappingURL=AclDenyFieldsStmt.js.map